import PageNotFoundLg from '../../assets/images/Seitenichtgefunden-lg-rgb.svg';
import PageNotFoundXs from '../../assets/images/Seitenichtgefunden-xs-rgb.svg';
import React from 'react';
import { ReactSVG } from 'react-svg';
import { useMediaQuery } from 'usehooks-ts';

export default function PageNotFoundHeader() {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    return (
        <div>
            <ReactSVG src={isDesktop ? PageNotFoundLg : PageNotFoundXs} />
        </div>
    );
}
